var styles = {"box":"FA2Modal_box_1o63o_1","pulldown":"FA2Modal_pulldown_1o63o_11"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
